export function getSelectElementWidthPx(groupingLength: number): string {
  return `${getSelectElementWidth(groupingLength)}px`;
}

export function getSelectElementWidth(groupingLength: number): number {
  return 40 + groupingLength * 16;
}
